import React, { useState } from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import { 
  AutoFixHigh as WizardIcon,
  Help as QuestionsIcon,
  Note as NoteIcon
} from '@mui/icons-material';
import ProjectWizard from './ProjectWizard';
import Questions from '../Note/Questions';
import Notes from '../Note/Notes';

export default function ProjectMaker({ item, pattern, currentStep, connectionIndex, onStepChange }) {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  // Find the step index in the pattern
  const findStepIndex = (step) => {
    if (!pattern?.steps) return 0;
    
    const findStep = (steps, targetStep, currentPath = '') => {
      for (let i = 0; i < steps.length; i++) {
        const stepId = currentPath ? `${currentPath}_${i}` : `${i}`;
        if (steps[i] === targetStep) {
          return stepId;
        }
        if (steps[i].steps) {
          const result = findStep(steps[i].steps, targetStep, stepId);
          if (result) return result;
        }
      }
      return null;
    };

    return findStep(pattern.steps, step) || '0';
  };

  // Determine which tabs to show based on step properties
  const getTabs = () => {
    const tabs = [];
    const stepId = currentStep?.stepId || findStepIndex(currentStep);
    const stepIndex = currentStep?.stepIndex ?? parseInt(stepId.split('_')[0]);
    
    if (currentStep?.withInstructions) {
      tabs.push({
        label: 'Instructions',
        icon: <WizardIcon />,
        component: (
          <ProjectWizard
            item={item}
            stepIndex={stepIndex}
            stepId={stepId}
            connectionIndex={connectionIndex}
            pattern={pattern}
            onStepChange={onStepChange}
            initialStep={currentStep}
          />
        )
      });
    }
    
    if (currentStep?.questions) {
      tabs.push({
        label: 'Questions',
        icon: <QuestionsIcon />,
        component: (
          <Questions
            item={item}
            connectionIndex={connectionIndex}
            currentStep={currentStep}
            stepIndex={stepIndex}
          />
        )
      });
    }
    
    if (currentStep?.withNotes) {
      tabs.push({
        label: 'Notes',
        icon: <NoteIcon />,
        component: (
          <Notes
            project={item}
            connectionIndex={connectionIndex}
            currentStepId={currentStep.stepId}
          />
        )
      });
    }

    return tabs;
  };

  const tabs = getTabs();

  if (tabs.length === 0) {
    return null;
  }

  return (
    <Box>
      <Tabs
        value={activeTab}
        onChange={handleTabChange}
        variant="scrollable"
        scrollButtons="auto"
      >
        {tabs.map((tab, index) => (
          <Tab
            key={index}
            label={tab.label}
            icon={tab.icon}
            iconPosition="start"
          />
        ))}
      </Tabs>
      <Box sx={{ mt: 2 }}>
        {tabs[activeTab].component}
      </Box>
    </Box>
  );
} 